module.exports = __webpack_public_path__ + "img/8_kim_s.64c172fc.png";